module.exports = __webpack_public_path__ + "static/images/logo.4f05fe1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 0